import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'antd/lib/button';
import Result from 'antd/lib/result';
import { t } from 'utils/i18n';

// The workspace has no app header, so this page needs its own way out.
export default function JobNotFound(): JSX.Element {
    return (
        <Result
            className='cvat-not-found'
            status='404'
            title={t('Sorry, but this job was not found')}
            subTitle={t('Please, be sure information you tried to get exist and you have access')}
            extra={(
                <Link to='/projects'>
                    <Button type='primary'>{t('Back to projects')}</Button>
                </Link>
            )}
        />
    );
}
